import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

export default function Location() {
    const { t } = useT();
    const highlights = [
        { title: t("loc.h1_title"), body: t("loc.h1_body") },
        { title: t("loc.h2_title"), body: t("loc.h2_body") },
        { title: t("loc.h3_title"), body: t("loc.h3_body") },
    ];
    return (
        <section
            id="location"
            className="relative py-24 md:py-32 bg-charcoal"
            data-testid="location-section"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="lg:col-span-5"
                >
                    <div className="flex items-center gap-3 mb-6">
                        <MapPin size={14} className="text-gold" />
                        <span className="text-[11px] tracking-[0.4em] uppercase text-gold font-semibold">
                            {t("loc.overline")}
                        </span>
                    </div>
                    <h2 className="font-display text-3xl md:text-5xl font-semibold tracking-tight leading-[1.05]">
                        {t("loc.heading")}
                    </h2>
                    <p className="mt-6 text-white/70 text-base md:text-lg leading-relaxed">
                        {t("loc.body")}
                    </p>

                    <div className="mt-10 space-y-0 border-t border-white/10">
                        {highlights.map((h, i) => (
                            <div
                                key={h.title}
                                className="py-5 border-b border-white/10 group"
                            >
                                <div className="flex items-baseline gap-4">
                                    <span className="font-display text-gold text-xs">
                                        0{i + 1}
                                    </span>
                                    <div>
                                        <div className="font-display text-lg md:text-xl font-medium">
                                            {h.title}
                                        </div>
                                        <div className="text-sm text-white/60 mt-1">
                                            {h.body}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, scale: 0.96 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.9 }}
                    className="lg:col-span-7 relative overflow-hidden aspect-[4/3] border border-white/10"
                >
                    <img
                        src="https://customer-assets.emergentagent.com/job_wynwood-short-term/artifacts/g8ohd223_Imagen%2021-4-26%20a%20las%2021.23.jpeg"
                        alt="Aerial view of Wynwood and Miami skyline at dusk"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/20 to-transparent" />
                    <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between text-[11px] tracking-[0.25em] uppercase">
                        <span className="text-white/80">{t("loc.address")}</span>
                        <span className="text-gold">25.8° N · 80.2° W</span>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
